export const orgs = {
    FEDERAL: "157"
};
